<template>
	<div id="apps">
		<!-- 头部 -->
		<HeaderTopView @childFn="parentFn($event)"></HeaderTopView>
		<HeaderView></HeaderView>
		<NavView></NavView>
		<!-- 内容 -->
		<div class="word">
			<div style="margin-right: 20px;">
				<el-collapse v-model="activeNames" @change="handleChange">
					<el-collapse-item :title="item.menuName" :name="index" v-for="(item,index) in arr" :key="index">
						<div v-for="(items,indexs) in item.children" @click="choice(items.id,index,indexs)" :key="indexs" :class="arr[idx].children[idxs].id == items.id ? 'c':''">{{items.menuName}}</div>
					</el-collapse-item>
				</el-collapse>
			</div>
			<div class="dv">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">{{ $t('nav.home') }}</el-breadcrumb-item>
					<el-breadcrumb-item>{{ $t('nav.afterSale') }}</el-breadcrumb-item>
					<el-breadcrumb-item>{{arr[idx].menuName}}</el-breadcrumb-item>
					<el-breadcrumb-item>{{arr[idx].children[idxs].menuName}}</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="box">
					<div class="title"><span>{{arr[idx].children[idxs].menuName}}</span></div>
					<div v-html="msg" style="text-align: left;" class="msg"></div>
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import HeaderTopView from '@/components/assembly/HeaderTop.vue'; //头部模块
	import HeaderView from '@/components/assembly/Header.vue'; //头部模块
	import NavView from '@/components/assembly/Nav.vue'; //导航模块
	import Footer from '@/components/assembly/Footer.vue'; //导航模块
	export default {
		name: "AboutUs",
		data() {
			return {
				msg: '',
				activeNames: [],
				arr: [],
				idx: 0,
				idxs: 0
			}
		},
		components: {
			HeaderView,
			NavView,
			HeaderTopView,
			Footer
		},
		methods: {
			handleChange(val) {
				console.log(val);
			},
			choice(id, index, indexs) {
				this.idx = index
				this.idxs = indexs
				this.getData()
			},
			getData() {
				let url = '/open/help/center/detail'
				let data = {
					id: this.arr[this.idx].children[this.idxs].id
				}
				this.$post(url, data).then(res => {
					this.msg = res.data.content
				})
			},
			getNav() {
				let url = '/open/help/center/entry'
				let data = {

				}
				this.$post(url, data).then(res => {
					let arr = [],
						brr = []
					res.data.map((item, index) => {
						this.activeNames.push(index)
						if (item.leave == 1) {
							item.children = []
							arr.push(item)
						} else {
							brr.push(item)
						}
					})
					arr.map(item => {
						brr.map(items => {
							if (item.pkid == items.parentId) {
								item.children.push(items)
							}
						})
					})
					this.arr = arr
					this.getData()
				})
			}
		},
		mounted() {
			this.getNav()
		}
	}
</script>
<style scoped>
	#apps {
		background: #F6F6F6;
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
	.msg >>> a{
		display: inline-block !important;
		color: #0090ff;
	}
	.c {
		color: #0090ff;
	}

	.word {
		margin-top: 10px;
		display: flex;
		flex: 1;
	}

	.el-collapse {
		width: 200px;
	}

	.word>>>.el-collapse-item__header {
		background-color: #EAEAEA;
		padding: 0 20px;
		font-size: 13rpx;
		border-bottom: solid 1px #fff;
	}

	.word>>>.el-collapse-item__content {
		padding-bottom: 0;
	}

	.el-collapse-item__content div {
		text-align: left;
		line-height: 48px;
		padding: 0 20px;
		border-bottom: solid 1px #f5f5f5;
		cursor: pointer;
		font-size: 12px
	}

	.el-collapse-item__content div:hover {
		color: #0090ff;
	}

	.dv {
		width: 100%;
	}

	.el-breadcrumb {
		background: #eaeaea;
		padding: 0 20px;
		line-height: 49px;
	}

	.box {
		padding: 20px;
		background: #fff;
	}

	.title {
		border-bottom: 1px solid #e4e4e4;
		padding-bottom: 12px;
		font-weight: 700 !important;
		font-size: 14px;
		text-align: left;
		position: relative;
		margin-bottom: 10px;
	}

	.title span {
		border-bottom: 2px solid #0090ff;
		padding-bottom: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/service/service.vue